import { ExtendedQuestionnaireBlock } from '../components/compliance/ExtendedQuestionnaire';

// SOC 2 Self-Assessment Questionnaire (Полная анкета самоаттестации SOC 2)
export const SOC2_SELF_ASSESSMENT_BLOCKS: ExtendedQuestionnaireBlock[] = [
  {
    id: 'cc1-control-environment',
    name_en: 'CC1 - Control Environment',
    name_es: 'CC1 - Entorno de Control',
    name_ru: 'CC1 - Контрольная среда',
    questions: [
      {
        id: 'cc1-1',
        blockId: 'cc1-control-environment',
        text_en: 'Is there an approved code of ethics?',
        text_es: '¿Existe un código de ética aprobado?',
        text_ru: 'Есть ли утверждённый кодекс этики?',
      },
      {
        id: 'cc1-2',
        blockId: 'cc1-control-environment',
        text_en: 'Are roles and responsibilities in security defined?',
        text_es: '¿Están definidos los roles y responsabilidades en seguridad?',
        text_ru: 'Определены ли роли и ответственность в области безопасности?',
      },
      {
        id: 'cc1-3',
        blockId: 'cc1-control-environment',
        text_en: 'Is organizational structure and security hierarchy defined?',
        text_es: '¿Está definida la estructura organizacional y la jerarquía de seguridad?',
        text_ru: 'Определена ли оргструктура и подчинённость по безопасности?',
      },
      {
        id: 'cc1-4',
        blockId: 'cc1-control-environment',
        text_en: 'Is there an employee background check process?',
        text_es: '¿Existe un proceso de verificación de antecedentes de empleados?',
        text_ru: 'Есть ли процесс проверки сотрудников (background checks)?',
      },
      {
        id: 'cc1-5',
        blockId: 'cc1-control-environment',
        text_en: 'Do information security management policies exist?',
        text_es: '¿Existen políticas de gestión de seguridad de la información?',
        text_ru: 'Существуют ли политики управления информационной безопасностью?',
      },
      {
        id: 'cc1-6',
        blockId: 'cc1-control-environment',
        text_en: 'Are policies reviewed annually?',
        text_es: '¿Se revisan las políticas anualmente?',
        text_ru: 'Проводится ли ежегодный пересмотр политик?',
      },
    ],
  },
  {
    id: 'cc2-communication',
    name_en: 'CC2 - Communication & Information',
    name_es: 'CC2 - Comunicación e Información',
    name_ru: 'CC2 - Коммуникация и информация',
    questions: [
      {
        id: 'cc2-1',
        blockId: 'cc2-communication',
        text_en: 'Are security policies accessible to employees?',
        text_es: '¿Son accesibles las políticas de seguridad para los empleados?',
        text_ru: 'Доступны ли сотрудникам политики безопасности?',
      },
      {
        id: 'cc2-2',
        blockId: 'cc2-communication',
        text_en: 'Is there a channel for reporting violations/incidents?',
        text_es: '¿Existe un canal para reportar violaciones/incidentes?',
        text_ru: 'Есть ли канал для сообщения о нарушениях / инцидентах?',
      },
      {
        id: 'cc2-3',
        blockId: 'cc2-communication',
        text_en: 'Are employees informed about their security responsibilities?',
        text_es: '¿Se informa a los empleados sobre sus responsabilidades de seguridad?',
        text_ru: 'Информируются ли сотрудники о своих обязанностях в ИБ?',
      },
      {
        id: 'cc2-4',
        blockId: 'cc2-communication',
        text_en: 'Are customers notified about security requirements?',
        text_es: '¿Se notifica a los clientes sobre los requisitos de seguridad?',
        text_ru: 'Уведомляются ли клиенты о требованиях безопасности?',
      },
    ],
  },
  {
    id: 'cc3-risk-assessment',
    name_en: 'CC3 - Risk Assessment',
    name_es: 'CC3 - Evaluación de Riesgos',
    name_ru: 'CC3 - Оценка рисков',
    questions: [
      {
        id: 'cc3-1',
        blockId: 'cc3-risk-assessment',
        text_en: 'Is annual risk assessment performed?',
        text_es: '¿Se realiza una evaluación anual de riesgos?',
        text_ru: 'Выполняется ли ежегодная оценка рисков?',
      },
      {
        id: 'cc3-2',
        blockId: 'cc3-risk-assessment',
        text_en: 'Does a formal Risk Register exist?',
        text_es: '¿Existe un Registro de Riesgos formal?',
        text_ru: 'Существует ли формальный Risk Register?',
      },
      {
        id: 'cc3-3',
        blockId: 'cc3-risk-assessment',
        text_en: 'Are new risks identified when systems change?',
        text_es: '¿Se identifican nuevos riesgos cuando cambian los sistemas?',
        text_ru: 'Идентифицируются ли новые риски при изменениях систем?',
      },
      {
        id: 'cc3-4',
        blockId: 'cc3-risk-assessment',
        text_en: 'Are risk mitigation measures applied?',
        text_es: '¿Se aplican medidas de mitigación de riesgos?',
        text_ru: 'Применяются ли меры снижения рисков?',
      },
    ],
  },
  {
    id: 'cc4-monitoring',
    name_en: 'CC4 - Monitoring Activities',
    name_es: 'CC4 - Actividades de Monitoreo',
    name_ru: 'CC4 - Мониторинг',
    questions: [
      {
        id: 'cc4-1',
        blockId: 'cc4-monitoring',
        text_en: 'Is control execution monitored?',
        text_es: '¿Se monitorea la ejecución de controles?',
        text_ru: 'Выполняется ли мониторинг выполнения контролей?',
      },
      {
        id: 'cc4-2',
        blockId: 'cc4-monitoring',
        text_en: 'Is internal security audit conducted?',
        text_es: '¿Se realiza una auditoría interna de seguridad?',
        text_ru: 'Проводится ли внутренний аудит по ИБ?',
      },
      {
        id: 'cc4-3',
        blockId: 'cc4-monitoring',
        text_en: 'Are processes corrected based on audit results?',
        text_es: '¿Se corrigen los procesos basándose en los resultados de la auditoría?',
        text_ru: 'Корректируются ли процессы по результатам аудитов?',
      },
    ],
  },
  {
    id: 'cc5-control-activities',
    name_en: 'CC5 - Control Activities',
    name_es: 'CC5 - Actividades de Control',
    name_ru: 'CC5 - Контрольные действия',
    questions: [
      {
        id: 'cc5-1',
        blockId: 'cc5-control-activities',
        text_en: 'Are control activities documented?',
        text_es: '¿Están documentadas las actividades de control?',
        text_ru: 'Зафиксированы ли контрольные действия (control activities)?',
      },
      {
        id: 'cc5-2',
        blockId: 'cc5-control-activities',
        text_en: 'Is authorization performed for actions on critical resources?',
        text_es: '¿Se realiza autorización para acciones en recursos críticos?',
        text_ru: 'Проводится ли авторизация действий с критичными ресурсами?',
      },
      {
        id: 'cc5-3',
        blockId: 'cc5-control-activities',
        text_en: 'Is procedure execution correctness verified?',
        text_es: '¿Se verifica la corrección de la ejecución de procedimientos?',
        text_ru: 'Проверяется ли корректность выполнения процедур?',
      },
    ],
  },
  {
    id: 'cc6-access-controls',
    name_en: 'CC6 - Logical and Physical Access Controls',
    name_es: 'CC6 - Controles de Acceso Lógico y Físico',
    name_ru: 'CC6 - Логический и физический контроль доступа',
    questions: [
      {
        id: 'cc6-1',
        blockId: 'cc6-access-controls',
        text_en: 'Is centralized IAM implemented?',
        text_es: '¿Está implementado IAM centralizado?',
        text_ru: 'Реализован ли централизованный IAM?',
      },
      {
        id: 'cc6-2',
        blockId: 'cc6-access-controls',
        text_en: 'Is MFA configured for critical systems?',
        text_es: '¿Está configurado MFA para sistemas críticos?',
        text_ru: 'Настроен ли MFA для критичных систем?',
      },
      {
        id: 'cc6-3',
        blockId: 'cc6-access-controls',
        text_en: 'Are roles (RBAC) used?',
        text_es: '¿Se utilizan roles (RBAC)?',
        text_ru: 'Используются ли роли (RBAC)?',
      },
      {
        id: 'cc6-4',
        blockId: 'cc6-access-controls',
        text_en: 'Are regular access rights reviews conducted?',
        text_es: '¿Se realizan revisiones regulares de derechos de acceso?',
        text_ru: 'Проводятся ли регулярные ревизии прав доступа?',
      },
      {
        id: 'cc6-5',
        blockId: 'cc6-access-controls',
        text_en: 'Is access removed upon termination?',
        text_es: '¿Se elimina el acceso al terminar la relación laboral?',
        text_ru: 'Доступ удаляется при увольнении?',
      },
      {
        id: 'cc6-6',
        blockId: 'cc6-access-controls',
        text_en: 'Is physical access to office controlled?',
        text_es: '¿Está controlado el acceso físico a la oficina?',
        text_ru: 'Физический доступ к офису контролируется?',
      },
      {
        id: 'cc6-7',
        blockId: 'cc6-access-controls',
        text_en: 'Are server rooms protected?',
        text_es: '¿Están protegidas las salas de servidores?',
        text_ru: 'Серверные помещения защищены?',
      },
    ],
  },
  {
    id: 'cc7-system-operations',
    name_en: 'CC7 - System Operations',
    name_es: 'CC7 - Operaciones del Sistema',
    name_ru: 'CC7 - Системные операции',
    questions: [
      {
        id: 'cc7-1',
        blockId: 'cc7-system-operations',
        text_en: 'Is centralized logging configured?',
        text_es: '¿Está configurado el registro centralizado?',
        text_ru: 'Настроено ли централизованное логирование?',
      },
      {
        id: 'cc7-2',
        blockId: 'cc7-system-operations',
        text_en: 'Is there a SIEM or equivalent?',
        text_es: '¿Existe un SIEM o equivalente?',
        text_ru: 'Есть ли SIEM или аналог?',
      },
      {
        id: 'cc7-3',
        blockId: 'cc7-system-operations',
        text_en: 'Are critical events monitored?',
        text_es: '¿Se monitorean eventos críticos?',
        text_ru: 'Проводится ли мониторинг критичных событий?',
      },
      {
        id: 'cc7-4',
        blockId: 'cc7-system-operations',
        text_en: 'Is incident response implemented?',
        text_es: '¿Está implementada la respuesta a incidentes?',
        text_ru: 'Реализовано ли реагирование на инциденты?',
      },
      {
        id: 'cc7-5',
        blockId: 'cc7-system-operations',
        text_en: 'Is an incident log maintained?',
        text_es: '¿Se mantiene un registro de incidentes?',
        text_ru: 'Ведётся ли журнал инцидентов?',
      },
    ],
  },
  {
    id: 'cc8-change-management',
    name_en: 'CC8 - Change Management',
    name_es: 'CC8 - Gestión de Cambios',
    name_ru: 'CC8 - Управление изменениями',
    questions: [
      {
        id: 'cc8-1',
        blockId: 'cc8-change-management',
        text_en: 'Are all changes recorded in a ticket system?',
        text_es: '¿Se registran todos los cambios en un sistema de tickets?',
        text_ru: 'Все изменения фиксируются в тикет-системе?',
      },
      {
        id: 'cc8-2',
        blockId: 'cc8-change-management',
        text_en: 'Does each change go through review/approval?',
        text_es: '¿Cada cambio pasa por revisión/aprobación?',
        text_ru: 'Проходит ли каждое изменение review/approval?',
      },
      {
        id: 'cc8-3',
        blockId: 'cc8-change-management',
        text_en: 'Are changes tested before deployment?',
        text_es: '¿Se prueban los cambios antes del despliegue?',
        text_ru: 'Тестируются ли изменения перед выкладкой?',
      },
      {
        id: 'cc8-4',
        blockId: 'cc8-change-management',
        text_en: 'Is a change log maintained?',
        text_es: '¿Se mantiene un registro de cambios?',
        text_ru: 'Ведётся ли журнал изменений?',
      },
    ],
  },
  {
    id: 'cc9-risk-mitigation',
    name_en: 'CC9 - Risk Mitigation',
    name_es: 'CC9 - Mitigación de Riesgos',
    name_ru: 'CC9 - Снижение рисков',
    questions: [
      {
        id: 'cc9-1',
        blockId: 'cc9-risk-mitigation',
        text_en: 'Are malware protection measures applied?',
        text_es: '¿Se aplican medidas de protección contra malware?',
        text_ru: 'Применяются ли меры против malware?',
      },
      {
        id: 'cc9-2',
        blockId: 'cc9-risk-mitigation',
        text_en: 'Is vulnerability management conducted?',
        text_es: '¿Se realiza gestión de vulnerabilidades?',
        text_ru: 'Проводится ли управление уязвимостями?',
      },
      {
        id: 'cc9-3',
        blockId: 'cc9-risk-mitigation',
        text_en: 'Are backups implemented?',
        text_es: '¿Están implementados los respaldos?',
        text_ru: 'Реализованы ли бэкапы?',
      },
      {
        id: 'cc9-4',
        blockId: 'cc9-risk-mitigation',
        text_en: 'Is recovery testing performed?',
        text_es: '¿Se realiza prueba de recuperación?',
        text_ru: 'Проводится ли тест восстановления?',
      },
      {
        id: 'cc9-5',
        blockId: 'cc9-risk-mitigation',
        text_en: 'Is vendor management conducted?',
        text_es: '¿Se realiza gestión de proveedores?',
        text_ru: 'Проводится ли управление поставщиками?',
      },
    ],
  },
  {
    id: 'availability',
    name_en: 'Availability (A)',
    name_es: 'Disponibilidad (A)',
    name_ru: 'Доступность (A)',
    questions: [
      {
        id: 'avail-1',
        blockId: 'availability',
        text_en: 'Are availability requirements defined?',
        text_es: '¿Están definidos los requisitos de disponibilidad?',
        text_ru: 'Определены ли требования доступности?',
      },
      {
        id: 'avail-2',
        blockId: 'availability',
        text_en: 'Is uptime monitored?',
        text_es: '¿Se monitorea el tiempo de actividad?',
        text_ru: 'Проводится ли мониторинг uptime?',
      },
      {
        id: 'avail-3',
        blockId: 'availability',
        text_en: 'Is DRP implemented?',
        text_es: '¿Está implementado el DRP?',
        text_ru: 'Реализован ли DRP?',
      },
      {
        id: 'avail-4',
        blockId: 'availability',
        text_en: 'Is DR testing performed?',
        text_es: '¿Se realiza prueba de DR?',
        text_ru: 'Проводится ли тест DR?',
      },
    ],
  },
  {
    id: 'confidentiality',
    name_en: 'Confidentiality (C)',
    name_es: 'Confidencialidad (C)',
    name_ru: 'Конфиденциальность (C)',
    questions: [
      {
        id: 'conf-1',
        blockId: 'confidentiality',
        text_en: 'Are data encrypted at rest?',
        text_es: '¿Están cifrados los datos en reposo?',
        text_ru: 'Данные шифруются at rest?',
      },
      {
        id: 'conf-2',
        blockId: 'confidentiality',
        text_en: 'Are data encrypted in transit?',
        text_es: '¿Están cifrados los datos en tránsito?',
        text_ru: 'Данные шифруются in transit?',
      },
      {
        id: 'conf-3',
        blockId: 'confidentiality',
        text_en: 'Are encryption keys managed?',
        text_es: '¿Se gestionan las claves de cifrado?',
        text_ru: 'Управляются ли ключи шифрования?',
      },
      {
        id: 'conf-4',
        blockId: 'confidentiality',
        text_en: 'Is confidential information protection implemented?',
        text_es: '¿Está implementada la protección de información confidencial?',
        text_ru: 'Реализована ли защита конфиденциальной информации?',
      },
    ],
  },
  {
    id: 'processing-integrity',
    name_en: 'Processing Integrity (PI)',
    name_es: 'Integridad de Procesamiento (PI)',
    name_ru: 'Целостность обработки (PI)',
    questions: [
      {
        id: 'pi-1',
        blockId: 'processing-integrity',
        text_en: 'Is data processing correctness verified?',
        text_es: '¿Se verifica la corrección del procesamiento de datos?',
        text_ru: 'Проверяется ли корректность обработки данных?',
      },
      {
        id: 'pi-2',
        blockId: 'processing-integrity',
        text_en: 'Is there error control?',
        text_es: '¿Existe control de errores?',
        text_ru: 'Есть ли контроль ошибок?',
      },
      {
        id: 'pi-3',
        blockId: 'processing-integrity',
        text_en: 'Are data processing processes audited?',
        text_es: '¿Se auditan los procesos de procesamiento de datos?',
        text_ru: 'Аудируются ли процессы обработки данных?',
      },
    ],
  },
  {
    id: 'privacy',
    name_en: 'Privacy (P)',
    name_es: 'Privacidad (P)',
    name_ru: 'Приватность (P)',
    questions: [
      {
        id: 'priv-1',
        blockId: 'privacy',
        text_en: 'Is there a Privacy Policy?',
        text_es: '¿Existe una Política de Privacidad?',
        text_ru: 'Есть ли Privacy Policy?',
      },
      {
        id: 'priv-2',
        blockId: 'privacy',
        text_en: 'Is consent management implemented?',
        text_es: '¿Está implementada la gestión de consentimientos?',
        text_ru: 'Реализовано ли управление согласиями?',
      },
      {
        id: 'priv-3',
        blockId: 'privacy',
        text_en: 'Are data subject requests processed?',
        text_es: '¿Se procesan las solicitudes de los sujetos de datos?',
        text_ru: 'Выполняются ли запросы субъектов данных?',
      },
      {
        id: 'priv-4',
        blockId: 'privacy',
        text_en: 'Is personal data retention period managed?',
        text_es: '¿Se gestiona el período de retención de datos personales?',
        text_ru: 'Управляется ли срок хранения персональных данных?',
      },
    ],
  },
];

// SOC 2 Documents Checklist
export const SOC2_DOCUMENTS_BLOCKS: ExtendedQuestionnaireBlock[] = [
  {
    id: 'doc-policies',
    name_en: 'Policies',
    name_es: 'Políticas',
    name_ru: 'Политики',
    questions: [
      {
        id: 'doc-pol-1',
        blockId: 'doc-policies',
        text_en: 'Information Security Policy',
        text_es: 'Política de Seguridad de la Información',
        text_ru: 'Information Security Policy',
      },
      {
        id: 'doc-pol-2',
        blockId: 'doc-policies',
        text_en: 'Access Control Policy',
        text_es: 'Política de Control de Acceso',
        text_ru: 'Access Control Policy',
      },
      {
        id: 'doc-pol-3',
        blockId: 'doc-policies',
        text_en: 'Change Management Policy',
        text_es: 'Política de Gestión de Cambios',
        text_ru: 'Change Management Policy',
      },
      {
        id: 'doc-pol-4',
        blockId: 'doc-policies',
        text_en: 'Incident Response Policy',
        text_es: 'Política de Respuesta a Incidentes',
        text_ru: 'Incident Response Policy',
      },
      {
        id: 'doc-pol-5',
        blockId: 'doc-policies',
        text_en: 'Business Continuity & DR Policy',
        text_es: 'Política de Continuidad del Negocio y DR',
        text_ru: 'Business Continuity & DR Policy',
      },
      {
        id: 'doc-pol-6',
        blockId: 'doc-policies',
        text_en: 'Data Classification Policy',
        text_es: 'Política de Clasificación de Datos',
        text_ru: 'Data Classification Policy',
      },
      {
        id: 'doc-pol-7',
        blockId: 'doc-policies',
        text_en: 'Logging & Monitoring Policy',
        text_es: 'Política de Registro y Monitoreo',
        text_ru: 'Logging & Monitoring Policy',
      },
      {
        id: 'doc-pol-8',
        blockId: 'doc-policies',
        text_en: 'Vendor Management Policy',
        text_es: 'Política de Gestión de Proveedores',
        text_ru: 'Vendor Management Policy',
      },
      {
        id: 'doc-pol-9',
        blockId: 'doc-policies',
        text_en: 'Risk Management Policy',
        text_es: 'Política de Gestión de Riesgos',
        text_ru: 'Risk Management Policy',
      },
      {
        id: 'doc-pol-10',
        blockId: 'doc-policies',
        text_en: 'Secure SDLC / Application Security Policy',
        text_es: 'Política de SDLC Seguro / Seguridad de Aplicaciones',
        text_ru: 'Secure SDLC / Application Security Policy',
      },
      {
        id: 'doc-pol-11',
        blockId: 'doc-policies',
        text_en: 'Physical Security Policy',
        text_es: 'Política de Seguridad Física',
        text_ru: 'Physical Security Policy',
      },
      {
        id: 'doc-pol-12',
        blockId: 'doc-policies',
        text_en: 'Encryption & Key Management Policy',
        text_es: 'Política de Cifrado y Gestión de Claves',
        text_ru: 'Encryption & Key Management Policy',
      },
      {
        id: 'doc-pol-13',
        blockId: 'doc-policies',
        text_en: 'Acceptable Use Policy',
        text_es: 'Política de Uso Aceptable',
        text_ru: 'Acceptable Use Policy',
      },
      {
        id: 'doc-pol-14',
        blockId: 'doc-policies',
        text_en: 'Privacy Policy (if P is included)',
        text_es: 'Política de Privacidad (si P está incluido)',
        text_ru: 'Privacy Policy (если P включён)',
      },
    ],
  },
  {
    id: 'doc-registers',
    name_en: 'Registers',
    name_es: 'Registros',
    name_ru: 'Регистры',
    questions: [
      {
        id: 'doc-reg-1',
        blockId: 'doc-registers',
        text_en: 'Risk Register',
        text_es: 'Registro de Riesgos',
        text_ru: 'Risk Register',
      },
      {
        id: 'doc-reg-2',
        blockId: 'doc-registers',
        text_en: 'Asset Register',
        text_es: 'Registro de Activos',
        text_ru: 'Asset Register',
      },
      {
        id: 'doc-reg-3',
        blockId: 'doc-registers',
        text_en: 'Vendor Register',
        text_es: 'Registro de Proveedores',
        text_ru: 'Vendor Register',
      },
      {
        id: 'doc-reg-4',
        blockId: 'doc-registers',
        text_en: 'Incident Register',
        text_es: 'Registro de Incidentes',
        text_ru: 'Incident Register',
      },
      {
        id: 'doc-reg-5',
        blockId: 'doc-registers',
        text_en: 'Change Register',
        text_es: 'Registro de Cambios',
        text_ru: 'Change Register',
      },
      {
        id: 'doc-reg-6',
        blockId: 'doc-registers',
        text_en: 'Access Review Register',
        text_es: 'Registro de Revisión de Accesos',
        text_ru: 'Access Review Register',
      },
      {
        id: 'doc-reg-7',
        blockId: 'doc-registers',
        text_en: 'Backup Register',
        text_es: 'Registro de Respaldos',
        text_ru: 'Backup Register',
      },
      {
        id: 'doc-reg-8',
        blockId: 'doc-registers',
        text_en: 'Vulnerability Scan Register',
        text_es: 'Registro de Escaneo de Vulnerabilidades',
        text_ru: 'Vulnerability Scan Register',
      },
    ],
  },
  {
    id: 'doc-procedures',
    name_en: 'Procedures',
    name_es: 'Procedimientos',
    name_ru: 'Процедуры',
    questions: [
      {
        id: 'doc-proc-1',
        blockId: 'doc-procedures',
        text_en: 'Joiner–Mover–Leaver procedure',
        text_es: 'Procedimiento Joiner–Mover–Leaver',
        text_ru: 'Joiner–Mover–Leaver procedure',
      },
      {
        id: 'doc-proc-2',
        blockId: 'doc-procedures',
        text_en: 'Incident Response Procedure',
        text_es: 'Procedimiento de Respuesta a Incidentes',
        text_ru: 'Incident Response Procedure',
      },
      {
        id: 'doc-proc-3',
        blockId: 'doc-procedures',
        text_en: 'Change Management SOP',
        text_es: 'SOP de Gestión de Cambios',
        text_ru: 'Change Management SOP',
      },
      {
        id: 'doc-proc-4',
        blockId: 'doc-procedures',
        text_en: 'Access Review Procedure',
        text_es: 'Procedimiento de Revisión de Accesos',
        text_ru: 'Access Review Procedure',
      },
      {
        id: 'doc-proc-5',
        blockId: 'doc-procedures',
        text_en: 'Backup & Restore Procedure',
        text_es: 'Procedimiento de Respaldo y Restauración',
        text_ru: 'Backup & Restore Procedure',
      },
      {
        id: 'doc-proc-6',
        blockId: 'doc-procedures',
        text_en: 'Vulnerability Management Procedure',
        text_es: 'Procedimiento de Gestión de Vulnerabilidades',
        text_ru: 'Vulnerability Management Procedure',
      },
      {
        id: 'doc-proc-7',
        blockId: 'doc-procedures',
        text_en: 'Vendor onboarding procedure',
        text_es: 'Procedimiento de incorporación de proveedores',
        text_ru: 'Vendor onboarding procedure',
      },
      {
        id: 'doc-proc-8',
        blockId: 'doc-procedures',
        text_en: 'DR Testing procedure',
        text_es: 'Procedimiento de prueba de DR',
        text_ru: 'DR Testing procedure',
      },
      {
        id: 'doc-proc-9',
        blockId: 'doc-procedures',
        text_en: 'Logging & Monitoring SOP',
        text_es: 'SOP de Registro y Monitoreo',
        text_ru: 'Logging & Monitoring SOP',
      },
    ],
  },
  {
    id: 'doc-technical',
    name_en: 'Technical Evidence',
    name_es: 'Evidencia Técnica',
    name_ru: 'Техническое evidence',
    questions: [
      {
        id: 'doc-tech-1',
        blockId: 'doc-technical',
        text_en: 'MFA screenshots',
        text_es: 'Capturas de pantalla de MFA',
        text_ru: 'MFA screenshots',
      },
      {
        id: 'doc-tech-2',
        blockId: 'doc-technical',
        text_en: 'IAM roles & permissions dump',
        text_es: 'Volcado de roles y permisos de IAM',
        text_ru: 'IAM roles & permissions dump',
      },
      {
        id: 'doc-tech-3',
        blockId: 'doc-technical',
        text_en: 'SIEM dashboards',
        text_es: 'Paneles de SIEM',
        text_ru: 'SIEM dashboards',
      },
      {
        id: 'doc-tech-4',
        blockId: 'doc-technical',
        text_en: 'Backup configuration evidence',
        text_es: 'Evidencia de configuración de respaldos',
        text_ru: 'Backup configuration evidence',
      },
      {
        id: 'doc-tech-5',
        blockId: 'doc-technical',
        text_en: 'DR test reports',
        text_es: 'Informes de prueba de DR',
        text_ru: 'DR test reports',
      },
      {
        id: 'doc-tech-6',
        blockId: 'doc-technical',
        text_en: 'Vulnerability scan results',
        text_es: 'Resultados de escaneo de vulnerabilidades',
        text_ru: 'Vulnerability scan results',
      },
      {
        id: 'doc-tech-7',
        blockId: 'doc-technical',
        text_en: 'Penetration test',
        text_es: 'Prueba de penetración',
        text_ru: 'Penetration test',
      },
      {
        id: 'doc-tech-8',
        blockId: 'doc-technical',
        text_en: 'System Architecture Diagram',
        text_es: 'Diagrama de Arquitectura del Sistema',
        text_ru: 'System Architecture Diagram',
      },
      {
        id: 'doc-tech-9',
        blockId: 'doc-technical',
        text_en: 'Network Diagram',
        text_es: 'Diagrama de Red',
        text_ru: 'Network Diagram',
      },
      {
        id: 'doc-tech-10',
        blockId: 'doc-technical',
        text_en: 'Sample change tickets',
        text_es: 'Tickets de cambio de muestra',
        text_ru: 'Sample change tickets',
      },
      {
        id: 'doc-tech-11',
        blockId: 'doc-technical',
        text_en: 'Sample access requests',
        text_es: 'Solicitudes de acceso de muestra',
        text_ru: 'Sample access requests',
      },
    ],
  },
];

// SOC 2 Processes Checklist
export const SOC2_PROCESSES_BLOCKS: ExtendedQuestionnaireBlock[] = [
  {
    id: 'proc-security',
    name_en: 'Security (required)',
    name_es: 'Seguridad (requerido)',
    name_ru: 'Security (обязательно)',
    questions: [
      {
        id: 'proc-sec-1',
        blockId: 'proc-security',
        text_en: 'Access Management (IAM lifecycle)',
        text_es: 'Gestión de Accesos (ciclo de vida de IAM)',
        text_ru: 'Управление доступом (IAM lifecycle)',
      },
      {
        id: 'proc-sec-2',
        blockId: 'proc-security',
        text_en: 'Vulnerability Management',
        text_es: 'Gestión de Vulnerabilidades',
        text_ru: 'Управление уязвимостями',
      },
      {
        id: 'proc-sec-3',
        blockId: 'proc-security',
        text_en: 'Change Management',
        text_es: 'Gestión de Cambios',
        text_ru: 'Управление изменениями',
      },
      {
        id: 'proc-sec-4',
        blockId: 'proc-security',
        text_en: 'Incident Response',
        text_es: 'Respuesta a Incidentes',
        text_ru: 'Incident Response',
      },
      {
        id: 'proc-sec-5',
        blockId: 'proc-security',
        text_en: 'Backup & DR',
        text_es: 'Respaldo y DR',
        text_ru: 'Backup & DR',
      },
      {
        id: 'proc-sec-6',
        blockId: 'proc-security',
        text_en: 'Patch Management',
        text_es: 'Gestión de Parches',
        text_ru: 'Patch Management',
      },
      {
        id: 'proc-sec-7',
        blockId: 'proc-security',
        text_en: 'Secure SDLC',
        text_es: 'SDLC Seguro',
        text_ru: 'Secure SDLC',
      },
      {
        id: 'proc-sec-8',
        blockId: 'proc-security',
        text_en: 'Monitoring & Logging',
        text_es: 'Monitoreo y Registro',
        text_ru: 'Monitoring & Logging',
      },
      {
        id: 'proc-sec-9',
        blockId: 'proc-security',
        text_en: 'Security Awareness Training',
        text_es: 'Capacitación en Conciencia de Seguridad',
        text_ru: 'Security Awareness Training',
      },
      {
        id: 'proc-sec-10',
        blockId: 'proc-security',
        text_en: 'Vendor Management',
        text_es: 'Gestión de Proveedores',
        text_ru: 'Vendor Management',
      },
      {
        id: 'proc-sec-11',
        blockId: 'proc-security',
        text_en: 'Network Security Management',
        text_es: 'Gestión de Seguridad de Red',
        text_ru: 'Network Security Management',
      },
      {
        id: 'proc-sec-12',
        blockId: 'proc-security',
        text_en: 'Risk Management',
        text_es: 'Gestión de Riesgos',
        text_ru: 'Risk Management',
      },
    ],
  },
  {
    id: 'proc-availability',
    name_en: 'Availability',
    name_es: 'Disponibilidad',
    name_ru: 'Availability',
    questions: [
      {
        id: 'proc-avail-1',
        blockId: 'proc-availability',
        text_en: 'Capacity Management',
        text_es: 'Gestión de Capacidad',
        text_ru: 'Capacity Management',
      },
      {
        id: 'proc-avail-2',
        blockId: 'proc-availability',
        text_en: 'Uptime Monitoring',
        text_es: 'Monitoreo de Tiempo de Actividad',
        text_ru: 'Uptime Monitoring',
      },
      {
        id: 'proc-avail-3',
        blockId: 'proc-availability',
        text_en: 'DRP Execution',
        text_es: 'Ejecución de DRP',
        text_ru: 'DRP Execution',
      },
      {
        id: 'proc-avail-4',
        blockId: 'proc-availability',
        text_en: 'Failover Testing',
        text_es: 'Prueba de Conmutación por Error',
        text_ru: 'Failover Testing',
      },
    ],
  },
  {
    id: 'proc-confidentiality',
    name_en: 'Confidentiality',
    name_es: 'Confidencialidad',
    name_ru: 'Confidentiality',
    questions: [
      {
        id: 'proc-conf-1',
        blockId: 'proc-confidentiality',
        text_en: 'Encryption management',
        text_es: 'Gestión de cifrado',
        text_ru: 'Encryption management',
      },
      {
        id: 'proc-conf-2',
        blockId: 'proc-confidentiality',
        text_en: 'Data retention & disposal',
        text_es: 'Retención y eliminación de datos',
        text_ru: 'Data retention & disposal',
      },
      {
        id: 'proc-conf-3',
        blockId: 'proc-confidentiality',
        text_en: 'Secrets Management',
        text_es: 'Gestión de Secretos',
        text_ru: 'Secrets Management',
      },
      {
        id: 'proc-conf-4',
        blockId: 'proc-confidentiality',
        text_en: 'Access segregation',
        text_es: 'Segregación de acceso',
        text_ru: 'Access segregation',
      },
    ],
  },
  {
    id: 'proc-processing-integrity',
    name_en: 'Processing Integrity',
    name_es: 'Integridad de Procesamiento',
    name_ru: 'Processing Integrity',
    questions: [
      {
        id: 'proc-pi-1',
        blockId: 'proc-processing-integrity',
        text_en: 'Data validation',
        text_es: 'Validación de datos',
        text_ru: 'Data validation',
      },
      {
        id: 'proc-pi-2',
        blockId: 'proc-processing-integrity',
        text_en: 'Error handling process',
        text_es: 'Proceso de manejo de errores',
        text_ru: 'Error handling process',
      },
      {
        id: 'proc-pi-3',
        blockId: 'proc-processing-integrity',
        text_en: 'Transaction logging',
        text_es: 'Registro de transacciones',
        text_ru: 'Transaction logging',
      },
    ],
  },
  {
    id: 'proc-privacy',
    name_en: 'Privacy',
    name_es: 'Privacidad',
    name_ru: 'Privacy',
    questions: [
      {
        id: 'proc-priv-1',
        blockId: 'proc-privacy',
        text_en: 'Consent management',
        text_es: 'Gestión de consentimientos',
        text_ru: 'Consent management',
      },
      {
        id: 'proc-priv-2',
        blockId: 'proc-privacy',
        text_en: 'DSAR processing',
        text_es: 'Procesamiento de DSAR',
        text_ru: 'DSAR processing',
      },
      {
        id: 'proc-priv-3',
        blockId: 'proc-privacy',
        text_en: 'Privacy impact assessments',
        text_es: 'Evaluaciones de impacto en la privacidad',
        text_ru: 'Privacy impact assessments',
      },
      {
        id: 'proc-priv-4',
        blockId: 'proc-privacy',
        text_en: 'Data minimization review',
        text_es: 'Revisión de minimización de datos',
        text_ru: 'Data minimization review',
      },
    ],
  },
];

// SOC 2 Roles & Departments Checklist
export const SOC2_ROLES_BLOCKS: ExtendedQuestionnaireBlock[] = [
  {
    id: 'roles-executive',
    name_en: 'Executive Roles',
    name_es: 'Roles Ejecutivos',
    name_ru: 'Исполнительные роли',
    questions: [
      {
        id: 'role-exec-1',
        blockId: 'roles-executive',
        text_en: 'Executive Sponsor (CEO/CTO)',
        text_es: 'Patrocinador Ejecutivo (CEO/CTO)',
        text_ru: 'Executive Sponsor (CEO/CTO)',
      },
    ],
  },
  {
    id: 'roles-security',
    name_en: 'Security Roles',
    name_es: 'Roles de Seguridad',
    name_ru: 'Роли безопасности',
    questions: [
      {
        id: 'role-sec-1',
        blockId: 'roles-security',
        text_en: 'CISO / Information Security Officer',
        text_es: 'CISO / Oficial de Seguridad de la Información',
        text_ru: 'CISO / Information Security Officer',
      },
      {
        id: 'role-sec-2',
        blockId: 'roles-security',
        text_en: 'Security Engineer / Analyst',
        text_es: 'Ingeniero / Analista de Seguridad',
        text_ru: 'Security Engineer / Analyst',
      },
    ],
  },
  {
    id: 'roles-operations',
    name_en: 'Operations Roles',
    name_es: 'Roles de Operaciones',
    name_ru: 'Роли операций',
    questions: [
      {
        id: 'role-ops-1',
        blockId: 'roles-operations',
        text_en: 'DevOps / SRE',
        text_es: 'DevOps / SRE',
        text_ru: 'DevOps / SRE',
      },
      {
        id: 'role-ops-2',
        blockId: 'roles-operations',
        text_en: 'System Owners',
        text_es: 'Propietarios de Sistemas',
        text_ru: 'System Owners',
      },
      {
        id: 'role-ops-3',
        blockId: 'roles-operations',
        text_en: 'Product Owners',
        text_es: 'Propietarios de Productos',
        text_ru: 'Product Owners',
      },
      {
        id: 'role-ops-4',
        blockId: 'roles-operations',
        text_en: 'Engineering Leads',
        text_es: 'Líderes de Ingeniería',
        text_ru: 'Engineering Leads',
      },
    ],
  },
  {
    id: 'roles-support',
    name_en: 'Support Roles',
    name_es: 'Roles de Soporte',
    name_ru: 'Роли поддержки',
    questions: [
      {
        id: 'role-support-1',
        blockId: 'roles-support',
        text_en: 'HR (Joiner/Mover/Leaver)',
        text_es: 'RRHH (Joiner/Mover/Leaver)',
        text_ru: 'HR (Joiner/Mover/Leaver)',
      },
      {
        id: 'role-support-2',
        blockId: 'roles-support',
        text_en: 'Legal (contracts, privacy)',
        text_es: 'Legal (contratos, privacidad)',
        text_ru: 'Legal (contracts, privacy)',
      },
      {
        id: 'role-support-3',
        blockId: 'roles-support',
        text_en: 'DPO (if Privacy is included)',
        text_es: 'DPO (si se incluye Privacidad)',
        text_ru: 'DPO (если есть Privacy)',
      },
      {
        id: 'role-support-4',
        blockId: 'roles-support',
        text_en: 'Internal Audit / Compliance Manager',
        text_es: 'Auditoría Interna / Gerente de Cumplimiento',
        text_ru: 'Internal Audit / Compliance Manager',
      },
      {
        id: 'role-support-5',
        blockId: 'roles-support',
        text_en: 'Vendor Management Officer',
        text_es: 'Oficial de Gestión de Proveedores',
        text_ru: 'Vendor Management Officer',
      },
      {
        id: 'role-support-6',
        blockId: 'roles-support',
        text_en: 'Support Lead (user incidents)',
        text_es: 'Líder de Soporte (incidentes de usuarios)',
        text_ru: 'Support Lead (инциденты пользователей)',
      },
    ],
  },
];

export const SOC2_QUESTIONNAIRES = {
  SELF_ASSESSMENT: SOC2_SELF_ASSESSMENT_BLOCKS,
  DOCUMENTS: SOC2_DOCUMENTS_BLOCKS,
  PROCESSES: SOC2_PROCESSES_BLOCKS,
  ROLES: SOC2_ROLES_BLOCKS,
};




